// extracted by mini-css-extract-plugin
module.exports = {"vipTag":"d4bipM84","gray":"JgyGxIjC","gdVipTag":"dCOiNFWh"};